export var colorPreset = [
    {
        background: '#6C3E1E',
    },
    {
        background: '#CA0712',
    },
    {
        background: '#FB8013',
    },
    {
        background: '#E79402',
    },
    {
        background: '#FEC600',
    },
    {
        background: '#00534E',
    },
    {
        background: '#399C1C',
    },
    {
        background: '#7EC162',
    },
    {
        background: '#57CACD',
    },
    {
        background: '#01B6DB',
    },
    {
        background: '#23466C',
    },
    {
        background: '#4367D9',
    },
    {
        background: '#0082FF',
    },
    {
        background: '#6F4EC8',
    },
    {
        background: '#D41198',
    },
    {
        background: '#AD215C',
    },
    {
        background: '#9C8756',
    },
    {
        background: '#5D6F8C',
    },
    {
        background: '#515151',
    },
    {
        background: '#A1A1A1',
    },
];
//# sourceMappingURL=colorPreset.js.map